import React from 'react';
import clsx from 'clsx';
import {makeStyles} from 'tss-react/mui';
import Container from '@mui/material/Container';
import {PtrnEstilosGenerales} from '../../patronUtils';

const useStyles = makeStyles()((theme) => {
   return {
      containerRoot: PtrnEstilosGenerales.containerSimpleRoot(theme),
      containerMargin: PtrnEstilosGenerales.containerSimpleMargin(theme)
   };
});

export interface PtrnContainerSimpleProps {
   children: React.ReactNode;
   id: string;
   noMargin?: boolean;
}

function PtrnContainerSimple({children, id, noMargin}: PtrnContainerSimpleProps) {
   const {classes} = useStyles();
   return (
      <Container
         id={id}
         className={clsx(classes.containerRoot, {[classes.containerMargin]: !noMargin})}
      >
         {children}
      </Container>
   );
}

export default PtrnContainerSimple;
